import { useAdminUsers } from '../../api/useAdminUsers.ts';
import { Rad } from '../../innstillinger/Rad.tsx';
import { summen } from './modell.ts';

/**
 * Raden «Panelbrukere» på Organisasjon (DD-68 presisert 2026-09-25): verdien i én linje og
 * «Åpne ›». Lista er en egen side (`/organisasjon/brukere`); raden brettes ikke ut, og den er
 * ikke en del av sidens utkast. Den hentes bare for eier — Organisasjon finnes ikke for andre.
 */
export function PanelbrukereRad() {
  const liste = useAdminUsers(true);
  const s = summen(liste.data ?? []);
  const verdi = liste.isPending ? (
    'Henter …'
  ) : liste.isError ? (
    'Kunne ikke hentes'
  ) : (
    <>
      <strong>{s.personer}</strong>
      {s.venter ? ` · ${s.venter} venter på første innlogging` : ''}
      {s.ute ? ` · ${s.ute} deaktivert` : ''}
    </>
  );
  return <Rad id="panelbrukere" navn="Panelbrukere" handling="Åpne" til="/organisasjon/brukere" verdi={verdi} verdiSmal={liste.isPending ? 'Henter …' : liste.isError ? 'Kunne ikke hentes' : s.personer} />;
}
